import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IConfig } from '@cian/config/shared';
import { ILocation } from '../../types/location';
import {
  fetchSearchRegionsCities,
  ISearchRegionsCitiesResponse200 as TRes200,
  ISearchRegionsCitiesResponse400 as TRes400,
} from '../../repositories/geo-temp-layer/v1/search-regions-cities';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

export interface ISearchRegionsDeps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
}

export async function searchRegions(deps: ISearchRegionsDeps, query: string): Promise<ILocation[]> {
  const { httpApi, logger } = deps;
  const defaultData: ILocation[] = [];

  return fetchSearchRegionsCities<TRes200, TRes400>({
    httpApi,
    parameters: {
      query,
    },
  })
    .then(response => {
      if (response.statusCode === 200) {
        /** Возвращает только регионы (Регион = location с mainTownId) */
        return response.response.items.filter(item => item.mainTownId) as ILocation[];
      }

      throw new HttpBadStatusCodeError(`Bad request /v1/search-regions-cities/?query=${query}`, response.statusCode);
    })
    .catch(error => {
      if (HttpBadStatusCodeError.is(error)) {
        logger.error(error.message);
      } else {
        logger.error(`Unable to send request /v1/search-regions-cities/?query=${query}`, error);
      }

      return defaultData;
    });
}
